import { useAuth0 } from '@auth0/auth0-react';
import { useTypeOfUsers } from 'components/Dashboard/SidebarElements/parliamentarianUsers';
import preventLink from 'components/Dashboard/TagsList/prevenLink';
import { store } from 'components/Store';
import time from 'utils/time';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { Portal } from 'react-portal';
import { Link, useLocation } from 'react-router';

function CreditsButton({ type = 'email', className, numberOfCredits = 1, subtype }) {
  const globalState = useContext(store);
  const { state } = globalState;
  const { activePlan, remainingCredits } = state;
  const { nextBillingCycleMonthlyAnniversary, subscriptionStatus } = activePlan ?? {};
  const [showActions, setShowActions] = useState(false);
  const [dimentions, setDimentions] = useState({ top: 0, left: 0, opacity: 0 });

  const trialUser = subscriptionStatus === 'InTrial';
  const { isAuthenticated } = useAuth0();
  const { isParliamentarian } = useTypeOfUsers();

  const actionsContainer = useRef(null);
  const elementContainer = useRef(null);

  const location = useLocation();

  const creditsButtonCondition = isAuthenticated && typeof remainingCredits !== 'undefined';

  useEffect(() => {
    if (actionsContainer?.current && elementContainer?.current) {
      const updateDimentions = () => {
        const { top, height, left, width } = actionsContainer.current?.getBoundingClientRect() ?? {};
        const { width: elementWidth, height: elementHeight } = elementContainer?.current?.getBoundingClientRect() ?? {};
        const heighValue = top + height + 10;
        setDimentions({
          top: `${heighValue + elementHeight > window.innerHeight ? top - elementHeight - 10 : heighValue}px`,
          left: `${left + width + (type === 'email' ? 18 : 0) - elementWidth}px`,
          opacity: 1,
        });
      };
      updateDimentions();
      window.addEventListener('resize', updateDimentions);
      return () => {
        window.removeEventListener('resize', updateDimentions);
      };
    }
  }, [showActions]);

  return (
    <>
      {creditsButtonCondition && (
        <div className='position-relative' ref={actionsContainer}>
          <button
            className={`position-relative d-flex align-items-center general-button credits-button  ${className ?? ''}`}
            onClick={(e) => {
              preventLink(e);
              setShowActions(!showActions);
            }}
          >
            <span className='stars-group-container'>
              <span className='stars-group'>
                <StarImage className={'star-1'} />
                <StarImage className={'star-2'} />
                <StarImage className={'star-3'} />
              </span>
            </span>
            {subtype === 'assistantPolicymaker' ? (
              <span>{remainingCredits} AI credits remaining </span>
            ) : (
              <span className='light-75-text nowrap-item credits-text'>{numberOfCredits}</span>
            )}
            {/* {!hideDots && <span className='icon-three-dots light-75-text ml-1' />} */}
          </button>

          {showActions && (
            <Portal>
              <div
                className='general-close-background adjustment-of-position'
                onClick={(e) => {
                  preventLink(e);
                  setShowActions(false);
                }}
              />
              <div
                className='box box-shadow py-2 credits-button-action-box p-4 text-left adjustment-of-position'
                style={{
                  position: 'fixed',
                  top: `${dimentions?.top}`,
                  left: `${dimentions?.left}`,
                  opacity: dimentions?.opacity,
                }}
                ref={elementContainer}
              >
                <div className='position-relative'>
                  <p className='title-h5-bold mb-2'>
                    This action will cost {numberOfCredits} credit{numberOfCredits === 1 ? '' : 's'}
                  </p>
                  <p className='paragraph-p1 white-space-normal mb-0'>
                    Your team has {remainingCredits} {type} credit{remainingCredits > 0 ? 's' : ''} remaining
                    {trialUser
                      ? ' during your trial.'
                      : `${subtype === 'assistantPolicymaker' ? '.' : ' this month.'} Your credits reset on ${time(nextBillingCycleMonthlyAnniversary).format('D MMMM')}.`}
                  </p>
                  {!isParliamentarian && !trialUser && (
                    <Link
                      className={`general-button action-button py-2 px-3 text-white d-inline-block mt-3`}
                      to={`/pricing?returnUrl=${encodeURIComponent(location.pathname)}`}
                      id={'credits-button-link'}
                    >
                      Get more credits
                    </Link>
                  )}
                </div>
              </div>
            </Portal>
          )}
        </div>
      )}
    </>
  );
}

const StarImage = ({ className }) => {
  return (
    <svg className={`star ${className}`} viewBox='0 0 60 60'>
      <path d='M30.05,0l8.12,21.93,21.93,8.12-21.93,8.12-8.12,21.93-8.12-21.93L0,30.05l21.93-8.12L30.05,0Z' />
    </svg>
  );
};

export default CreditsButton;
